import React from "react";
import {get} from "lodash";
import styled from "@emotion/styled";
import {useTranslation} from "react-i18next";
import {useSelector} from "react-redux";
import {LINE_UP} from "modules/constants";
import {Language, PlayerPositionEnum} from "modules/enums";
import {getPlayerByPosition} from "modules/selectors";
import {PlayerEmpty, PlayerFilled} from "components";
import {breakpoints, fieldsImages} from "assets/theme";
import pageMobileBg from "assets/images/pageMobileBg.png";

const PlayersGrid = styled.div`
	position: absolute;
	left: 0;
	right: 0;
	top: 50%;
	transform: translateY(-50%);
`;

const Wrapper = styled.div`
	position: relative;
	width: 100%;
	background: url(${pageMobileBg}) no-repeat center ${({theme}) => theme.colorPalette.black};
	background-size: 100% 100%;

	@media (min-width: ${breakpoints.tablet}) {
		background: none;
	}
`;

const FieldImage = styled.img`
	width: 100%;
	height: 100%;
	max-height: 770px;
`;

export const Field: React.FC = () => {
	const {i18n} = useTranslation();
	const language = i18n.language as Language;
	const fieldImage = get(fieldsImages, language, "");

	return (
		<Wrapper>
			<FieldImage src={fieldImage} alt="Field Image" />
			<PlayersGrid>
				{LINE_UP.map((item) => (
					<PlayersRow players={item} key={item[0]} />
				))}
			</PlayersGrid>
		</Wrapper>
	);
};

const PlayerRowElement = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	gap: 10px;
	margin-bottom: 40px;

	@media screen and (max-width: ${breakpoints.mobile}) {
		margin-bottom: 28px;
	}
`;

interface IRowProps {
	players: PlayerPositionEnum[];
}

const PlayersRow: React.FC<IRowProps> = ({players}) => {
	return (
		<PlayerRowElement>
			{players.map((position) => (
				<RowHandler position={position} key={position} />
			))}
		</PlayerRowElement>
	);
};

export interface IRowProp {
	position: PlayerPositionEnum;
}

const RowHandler: React.FC<IRowProp> = ({position}) => {
	const playerId = useSelector(getPlayerByPosition)(position);

	if (!playerId) {
		return <PlayerEmpty position={position} />;
	}

	return <PlayerFilled playerId={playerId} position={position} />;
};
